import { render, staticRenderFns } from "./RepairBox.vue?vue&type=template&id=7b330ea1&scoped=true"
import script from "./RepairBox.vue?vue&type=script&lang=js"
export * from "./RepairBox.vue?vue&type=script&lang=js"
import style0 from "./RepairBox.vue?vue&type=style&index=0&id=7b330ea1&scoped=true&lang=scss"
import style1 from "./RepairBox.vue?vue&type=style&index=1&id=7b330ea1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b330ea1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b330ea1')) {
      api.createRecord('7b330ea1', component.options)
    } else {
      api.reload('7b330ea1', component.options)
    }
    module.hot.accept("./RepairBox.vue?vue&type=template&id=7b330ea1&scoped=true", function () {
      api.rerender('7b330ea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/RepairBox.vue"
export default component.exports